
import './styles.css';
import InsaneTable from '../../component/insane-table'

//////////// REDUX | STORE | SERVICE /////////////
import { HttpRequest } from '../../service/HttpRequest';

function ProductionResultPDChecksheet(props) {

    const PARAM = props.location.state;
    let plantList = [];
    
    HttpRequest("/admin/pd/plant/get", {}).then(data => {
        if (data.result === "OK") {
            for (let i = 0; i < data.plants.length; i++) {
                const _plant = data.plants[i];
                plantList.push({
                    displayName: _plant.plantid + " (" + _plant.plantname + ")" ,
                    value: _plant.plantid
                })
            }
        }
    });

    const tableOption = {
        tableName: "Checksheet",
        className: "",
        search: [
            // {
            //     reqName: "plantid",
            //     displayName: "Plant ID",
            //     placeholder: "Select Plant ID.",
            //     element: "select",
            //     option: plantList
            // }
        ],
        mapTable: [
            {
                displayName: "Name",
                attName: "checksheetname",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "ID",
                attName: "checksheetid",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Plant",
                attName: "plantid",
                type: "id",
                form: {
                    validate: true,
                    element: "select",
                    option: plantList
                }
            },
            {
                displayName: "Report",
                attName: "reportemail",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            }
        ],
        api: {
            view: {
                enable: true,
                url: "/admin/pd/checksheet/get",
                dataReq: {
                    "index": 0,
                    "count": 10,
                    "plantid": PARAM.plantid
                }
            },
            insert: {
                enable: false,
                url: "/admin/pd/checksheet/update",
                dataReq: {
                    "plantid": "",
                    "reportemail": "",
                    "checksheetname": ""
                }
            },
            update: {
                enable: true,
                url: "/admin/pd/checksheet/update",
                dataReq: {
                    "checksheetid": "",
                    "plantid": "",
                    "reportemail": "",
                    "checksheetname": ""
                }
            },
            delete: {
                enable: true,
                url: "/admin/pd/checksheet/delete",
                dataReq: {
                    "checksheetid": ""
                }
            }
        },
        action: [
            // {
            //     name: "Edit",
            //     mode: "modal-form", /// page, modal, form
            //     option: {
            //         type: "update"
            //     }
            // },
            {
                name: "Survey Result",
                mode: "page", /// page, modal, form
                option: {
                    url: "/d-rec-admin/main/production/result-pd/checksheet/survey"
                }
            }
        ]
    }

    return (
        <div className='content'>

            <div className='content-page'>
                <div className='head-content-page'>Select Check Sheet.</div>
                <InsaneTable option={tableOption}></InsaneTable>
            </div>

        </div >);
}

export default ProductionResultPDChecksheet;